import { useCallback, useEffect, useState } from "react";

import BackEndService from "../api/BackEndService";
import DeficiencyService from "../api/DeficiencyService";
import { Comment } from "../types/comment";

const useDeficiencyComments = (deficiencyId?: string) => {
  const [comments, setComments] = useState<Comment[]>([]);
  const [loadingComments, setLoadingComments] = useState(false);

  const fetchDeficiencyComments = useCallback(async () => {
    if (deficiencyId) {
      setLoadingComments(true);
      try {
        const { data } =
          await DeficiencyService.GetDeficiencyComments(deficiencyId);
        setComments(data);
      } catch (error) {
        console.error("Error fetching comments:", error);
      } finally {
        setLoadingComments(false);
      }
    }
  }, [deficiencyId]);

  const addComment = async (content: string) => {
    if (!deficiencyId) return;

    try {
      await BackEndService.AddComment({
        content,
        attachedTo: { type: "Incident", id: deficiencyId },
      });
      fetchDeficiencyComments();
    } catch (error) {
      console.error("Error adding comment:", error);
    }
  };

  useEffect(() => {
    fetchDeficiencyComments();
  }, [fetchDeficiencyComments]);

  return { comments, loadingComments, fetchDeficiencyComments, addComment };
};

export default useDeficiencyComments;
